import { PageLoading } from 'module/ui/components/atoms/loading';
import { FC } from 'react';
import { SignalsV2 } from 'components/organisms/signals-v2';
import { AccountLayout } from '../common/layout';
import { AccountsTabs, AccountsTabsType } from '../common/tab';
import { useCompanyFromUrl } from '../use-current-company';

export const AccountSignalsV2Page: FC = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading || company == null ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.SignalsV2} />}
      content={<SignalsV2 company={company} />}
      actions={{}}
    />
  );
};
